import { AnyAction } from "redux";
import { GET_EVENTS_LOCKER_LIST_FAILURE, GET_EVENTS_LOCKER_LIST_REQUEST, GET_EVENTS_LOCKER_LIST_SUCCESS, RESET_EVENTS_LOCKER_LIST_STATE } from "../constants/eventsLockerList.constants";

const initialState = {
    loading: false,
    data: [],
    error: '',
};

export const eventsLockerListReducer = (state = initialState, action: AnyAction) => {
    switch (action.type) {
        case GET_EVENTS_LOCKER_LIST_REQUEST:
            return {
                ...state,
                loading: true,
            };

        case GET_EVENTS_LOCKER_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
                errorMsg: '',
            };
        case GET_EVENTS_LOCKER_LIST_FAILURE:
            return {
                ...state,
                loading: false,
                data: [],
                error: action.payload,
            };

        case RESET_EVENTS_LOCKER_LIST_STATE:
            return {
                ...initialState
            }

        default:
            return state;
    }
}